/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconExposurePlus1 = createReactComponent("exposure-plus-1", "IconExposurePlus1", [
  ["path", { d: "M3 12h6", key: "svg-0" }],
  ["path", { d: "M6 9v6", key: "svg-1" }],
  ["path", { d: "M18 19v-14l-4 4", key: "svg-2" }]
]);

export { IconExposurePlus1 as default };
//# sourceMappingURL=IconExposurePlus1.js.map
